/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import { LIST_DEVICES_QUERY } from '../../listDevices/redux/listDevicesQuery';
import {
  CreateDeviceActions,
  CreateDeviceActionsType,
  createDeviceFailed,
  CreateDeviceRequest,
  createDeviceSucceeded,
} from './action';
import { createDeviceQuery } from './createDeviceQuery';
import { ListDevices } from './types';

export function createDeviceEpic(action$): Observable<CreateDeviceActions> {
  return action$.pipe(
    filter((action: CreateDeviceActionsType) => action.type === CreateDeviceActions.CREATE_DEVICE_REQUEST),
    switchMap(({ input }: CreateDeviceRequest) =>
      createDevice(input).then(createDeviceSucceeded).catch(createDeviceFailed),
    ),
  );
}

export async function createDevice(input) {
  console.log('📦 CreateDevice: Начинаем создание устройства');
  console.log('📦 Input:', JSON.stringify(input, null, 2));
  const graphQLClient = await setAuthenticatedClient();

  console.log('📦 GraphQL Client:', graphQLClient ? 'OK' : 'NULL');

  try {
    console.log('📤 Отправляем мутацию на сервер...');
    const {
      data: { createDevice: device },
    } = await graphQLClient.mutate({
      mutation: createDeviceQuery,
      variables: { input },
    });
    console.log('✅ Успех! Устройство создано:', device);

    const existingData = graphQLClient.cache.readQuery<{ listDevices: ListDevices }>({
      query: LIST_DEVICES_QUERY,
      variables: {
        input: {},
      },
    });

    if (existingData?.listDevices) {
      const { devices, total } = existingData?.listDevices;
      const result = {
        ...existingData.listDevices,
        devices: [...devices, device],
        total: total + 1,
      };

      graphQLClient.cache.writeQuery({
        query: LIST_DEVICES_QUERY,
        variables: { input: {} },
        data: {
          listDevices: result,
        },
      });
    }

    return device;
  } catch (e) {
    console.error('❌ Ошибка создания устройства:');
    console.error('   Full error:', e);
    console.error('   GraphQL errors:', e.graphQLErrors);
    console.error('   Network error:', e.networkError);
    console.error('   Network error status:', e.networkError?.statusCode);
    console.error('   Network error result:', e.networkError?.device);

    // Попробуем распарсить детали ошибки
    if (e.networkError?.device?.errors) {
      console.error('   Detailed errors:', JSON.stringify(e.networkError.device.errors, null, 2));
    }

    throw new Error('Failed to create device');
  }
}
